// extracted by mini-css-extract-plugin
module.exports = {"unsynchover":"styles_unsynchover__1s4xY","SyncButton":"styles_SyncButton__3AAf1"};